module.exports = __webpack_public_path__ + "static/media/site_logo_white.8bd46ca5.png";